module.exports = __webpack_public_path__ + "img/img2.c976a38d.svg";